export type CacheEntry<T> = {
  data: T;
  fetchedAt: Date;
};

export class ReportCache {
  private readonly store = new Map<string, CacheEntry<unknown>>();

  get<T>(key: string): CacheEntry<T> | null {
    const entry = this.store.get(key);
    return entry ? (entry as CacheEntry<T>) : null;
  }

  set<T>(key: string, entry: CacheEntry<T>): void {
    this.store.set(key, entry as CacheEntry<unknown>);
  }

  clear(): void {
    this.store.clear();
  }

  static buildKey(type: string, slugs: readonly string[], hours?: number): string {
    const base = `${type}|${[...slugs].sort().join(',')}`;
    return hours != null ? `${base}|${hours}` : base;
  }
}
